<template>
  <div>
    <el-card>
      <div
        slot="header"
        class="clearfix"
      >
        <span>总计</span>
      </div>
      <data-list
        :data="data"
        :columns="column"
        :loading="loading"
        :page="page"
        :page-size="page.pageSize"
        @page-size-changed="pageSizeChanged"
        @page-changed="pageChanged"
        @sort-change="sortChange"
      ></data-list>
    </el-card>
    <el-dialog
      title="网站入口排行"
      :visible.sync="dialogVisible"
    >
      <enquiry-entry
        :customer-id="obj.customerId"
        :time-type="timeType"
      ></enquiry-entry>
    </el-dialog>
  </div>

</template>

<script>
import mixin from "./mixin";
import api from "@/backend/apiConfig/apiConfig";
import listPageCreate from "@/mixins/listPageCreate";
import enquiryEntry from "@/components/enquiry/enquiryEntry";
const datalist = listPageCreate({
  searchConfig: {
    api: api.inquiry.inquiryService,
    method: "POST"
  },
  getQuery(obj, that) {
    return Object.assign({}, obj, {
      customerId: that.customerId,
      timeType: that.timeType
    });
  }
});
export default {
  name: "enquiryService",
  mixins: [mixin, datalist],
  components: {
    enquiryEntry
  },
  data() {
    const that = this;
    return {
      dialogVisible: false,
      obj: {},
      page: {
        currentPage: 1,
        totalRecords: 0,
        pageSize: 5
      },
      column: [
        {
          label: "客户名称",
          bind: "customerName"
        },
        {
          label: "客户行业",
          bind: "industryName"
        },
        {
          label: "询盘数量",
          bind: "num"
        },
        {
          label: "操作",
          type: "btnClick",
          align: "center",
          bind(row) {
            if (that.customerId && that.customerId !== "") {
              return [
                {
                  text: "查看入口排行",
                  trigger: that.getEntry
                }
              ];
            } else {
              return [
                {
                  text: "查看入口排行",
                  trigger: that.getEntry
                },
                {
                  text: "查看详细报告",
                  trigger: that.getDetail
                }
              ];
            }
          }
        }
      ]
    };
  },
  methods: {
    getEntry(row) {
      this.obj = row;
      this.dialogVisible = true;
    },
    getDetail(row) {
      this.$store.commit("SET_CUSTOMERID", row.customerId);
      this.$store.commit("SET_CUSOMERNAME", row.customerName);
      this.$router.push({
        path: "/enquiry/enquiryStatistics/enquiryStatisticsDetail",
        query: {
          id: row.customerId
        }
      });
    }
  }
};
</script>

<style scoped>
</style>
